// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_edu-agent_edu-agent_module_ts":"573c5acff33b3da5","src_app_idscan_idscan-routing_module_ts":"76b8e6f0d3a42bd0"}[chunkId] + ".js";
};